export const AllowedOrderStatusModel = [
  'PENDING',
  'CONFIRMED',
  'READY',
  'CLOSED',
  'REJECTED',
  'REFUNDED',
] as const;

export type OrderStatusModel = (typeof AllowedOrderStatusModel)[number];
